import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { BRAND } from "../../lib/constants";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div
          className="animate-spin rounded-full h-8 w-8 border-2 border-gray-200"
          style={{ borderTopColor: BRAND.bg }}
        />
      </div>
    );
  }

  return user ? <Outlet /> : <Navigate to="/login" replace />;
}
